export default __webpack_public_path__ + "static/media/box.3b1f301a.png";